import Box from "@mui/material/Box";

import { SizingTypeValue } from "../../../types/enums";
import TermSheetCell from "../../termSheet/TermSheetCell";
import ProcessorAssignedCell from "./ProcessorAssignedCell";

import CustomChip from "../CustomChip";

const headClass = {
  background: "#E4EAFF",
  color: "var(--New-Colors-BTN, #362866)",
  fontFamily: "Poppins",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  borderRadius: "none",
  borderRight: "1px solid #BFBFBF",
};

export const TableColumns = [
  {
    title: "Evaluation Id",
    id: "evaluationId",
    hidden: () => false,
    tbField: "evaluationId",
    renderCustom: (
      data: any,
      styles: any,
      handleDropdownSelection: any,
      onLinkClick: any,
    ) => {
      return (
        <span
          style={{
            cursor: "pointer",
          }}
        >
          <a
            href={onLinkClick(data.loanType, data.loanId, data.productType)}
            style={{
              textDecoration: "underline",
              cursor: "pointer",
              color: "var(--Primary-PrimaryMain-700, #40128B)",
              fontFamily: "Poppins",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "normal",
            }}
            className="eval-link"
          >
            {data.evaluationId}
          </a>
        </span>
      );
    },
    width: 140,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Application Name",
    id: "applicationName",
    hidden: () => false,
    tbField: "applicationName",
    width: 200,
    renderCustom: (data: any) => {
      return (
        <div
          style={{ textOverflow: "ellipsis", overflow: "hidden" }}
          title={data?.applicationName}
        >
          {data?.applicationName}
        </div>
      );
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Sizing Type",
    id: "sizingType",
    hidden: (props: any) => !props?.merchants,
    tbField: "sizingType",
    showDropDownFilter: true,
    width: 200,
    renderCustom: (data: any) => {
      return (
        <div
          style={{ textOverflow: "ellipsis", overflow: "hidden" }}
          title={data?.sizingType}
        >
          {data?.sizingType}
        </div>
      );
    },
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Loan Type",
    id: "loanType",
    hidden: () => false,
    showDropDownFilter: true,
    tbField: "productType",
    width: 136,
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Loan Amount",
    id: "loanAmount",
    hidden: () => false,
    tbField: "loanAmount",
    width: 140,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Interest Rate",
    id: "interestRate",
    hidden: () => false,
    tbField: "interestRate",
    width: 140,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Created On",
    id: "createdOn",
    hidden: () => false,
    tbField: "createdOn",
    width: 120,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Created By",
    id: "createdBy",
    showDropDownFilter: true,
    hidden: (data: any) =>
      data?.sizingType === SizingTypeValue.QUICK_LOAN_SIZING ||
      data?.isLoanOfficer,
    tbField: "createdBy",
    width: 180,
    renderCustom: (data: any) => {
      return (
        <div
          style={{ textOverflow: "ellipsis", overflow: "hidden" }}
          title={data?.createdBy}
        >
          {data?.createdBy}
        </div>
      );
    },
    headStyle: {
      ...headClass,
    },
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
  },
  {
    title: "Processor Assigned",
    id: "processorAssigned",
    hidden: () => false,
    tbField: "processorAssigned",
    width: 180,
    renderCustom: (data: any) => <ProcessorAssignedCell rowData={data} />,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Price Exception",
    id: "waiverStatus",
    hidden: (data: any) => !data?.merchants,
    showDropDownFilter: true,
    tbField: "waiverStatus",
    width: 220,
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Rate as of",
    id: "ratesAsOf",
    hidden: () => false,
    showDateRangeFilter: true,
    tbField: "ratesAsOf",
    width: 136,
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Term Sheet",
    id: "termSheet",
    hidden: (data: any) => !data.termSheet,
    tbField: "termSheet",
    width: 200,
    renderCustom: (data: any) => {
      const label = data?.termSheet;
      return (
        <div>
          {label === "Not Generated" ? (
            <div
              style={{ textOverflow: "ellipsis", overflow: "hidden" }}
              title={label}
            >
              {label}
            </div>
          ) : (
            <div>
              <TermSheetCell label={label} rowData={data} />
            </div>
          )}
        </div>
      );
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Street Address",
    id: "streetAddress",
    hidden: (data: any) =>
      data?.sizingType === SizingTypeValue.QUICK_LOAN_SIZING,
    tbField: "streetAddress",
    width: 260,
    renderCustom: (data: any) => {
      return (
        <div
          style={{ textOverflow: "ellipsis", overflow: "hidden" }}
          title={data?.streetAddress}
        >
          {data?.streetAddress}
        </div>
      );
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "City",
    id: "city",
    hidden: () => false,
    tbField: "city",
    width: 160,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Postal",
    id: "postal",
    hidden: () => false,
    tbField: "postal",
    width: 120,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Escalation Date",
    id: "escalationDate",
    hidden: ({
    isUnderwriter,
    sizingType,
  }: {
    isUnderwriter: boolean;
    sizingType: string;
  }) =>
    sizingType === SizingTypeValue.QUICK_LOAN_SIZING,
    tbField: "escalationDate",
    renderCustom: (
      data: any,
      styles: any,
      handleDropdownSelection: any,
      onLinkClick: any,
    ) => {
      const escalationObj = Array.isArray(data?.escalations)
        ? data?.escalations?.find(
            (ele: any) => ele?.underwritingStatus === "Pending",
          )
        : {};
      return (
        <span>
          {escalationObj?.createdOn
            ? new Date(escalationObj.createdOn).toLocaleDateString()
            : " - "}
        </span>
      );
    },
    width: 200,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Escalation Status",
    id: "status",
    showDropDownFilter: true,
    hidden: ({
    isUnderwriter,
    sizingType,
  }: {
    isUnderwriter: boolean;
    sizingType: string;
  }) =>
    sizingType === SizingTypeValue.QUICK_LOAN_SIZING,
    tbField: "status",
    renderCustom: (
      data: any,
      styles: any,
      handleDropdownSelection: any,
      onLinkClick: any,
    ) => {
      const escalationObj = Array.isArray(data?.escalations)
        ? data?.escalations?.[data?.escalations?.length - 1]
        : {};
      return (
        <Box>
          {escalationObj?.underwritingStatus ? (
            <CustomChip
              size="small"
              label={escalationObj?.underwritingStatus}
              className="pending-chip"
              variant="outlined"
            />
          ) : (
            <span> - </span>
          )}
        </Box>
      );
    },
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    width: 220,
    headStyle: {
      ...headClass,
    },
  },
  // {
  //   title: "Sizing Stage",
  //   id: "sizingType",
  //     hidden: (data: any)=> !data?.merchants,
  //   showDropDownFilter: true,
  //   tbField: "sizingType",
  //   width: 160,
  //   boxProps: {
  //     ml: "auto",
  //     lineHeight: 0,
  //     display: "flex",
  //     flexDirection: "row",
  //     alignItems: "center",

  //   },
  // },
];
